<template>
  <div class="my-2 flex flex-row gap-6 text-[0.8rem]">
    <InfusePropertyValue :title="t('iam.roles.level')" :title-icon="{ type: 'fal', name: 'sitemap' }">
      {{ levelTranslation }}
    </InfusePropertyValue>

    <InfuseTooltip :content="getScopeTooltip(asset, t)" offset-distance="4" v-if="asset && asset.shared !== undefined">
      <InfusePropertyValue :title="t('iam.roles.scope')">
        {{ getScopeText(asset, t) }}
      </InfusePropertyValue>
    </InfuseTooltip>

    <InfusePropertyValue :title="t('iam.roles.ranking')" v-if="asset && asset.ranking !== undefined">
      <div class="flex flex-row items-center gap-2">
        <font-awesome-icon :icon="getRankingIcon(asset.ranking)" class="text-neutral-600" />
        <span>{{ asset.ranking }}</span>
      </div>
    </InfusePropertyValue>

    <InfusePropertyValue
      v-if="asset?.tenantId"
      :title="t('iam.tenants.nav.details')"
      :title-icon="{ type: 'fal', name: 'cubes' }"
    >
      <router-link class="text-primary-500 hover:underline" :to="`/tenant/${asset.tenantId}`">
        {{ asset?.tenantName || '-' }}
        <font-awesome-icon :icon="['far', 'arrow-right-from-bracket']" class="ml-1" />
      </router-link>
    </InfusePropertyValue>

    <InfusePropertyValue
      v-if="asset?.organisationId"
      :title="t('iam.organisations.nav.details')"
      :title-icon="{ type: 'fal', name: 'cube' }"
    >
      <router-link class="text-primary-500 hover:underline" :to="`/organisation/${asset.organisationId}`">
        {{ asset?.organisationName || '-' }}
        <font-awesome-icon :icon="['far', 'arrow-right-from-bracket']" class="ml-1" />
      </router-link>
    </InfusePropertyValue>
  </div>
</template>

<script setup lang="ts">
import { useAssetLevel } from '@infuse/iam/composables';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { InfusePropertyValue, InfuseTooltip } from '@infuse/ui/components';
import { getScopeTooltip, getScopeText, getRankingIcon } from '@infuse/iam/role/ui';

const { t } = useI18n();
const { getLevelTranslation } = useAssetLevel();

const props = defineProps<{
  asset: {
    tenantId?: string;
    tenantName?: string;
    organisationId?: string;
    organisationName?: string;
    shared?: boolean;
    ranking?: number;
  };
}>();

const levelTranslation = computed(() => (props.asset ? getLevelTranslation(props.asset) : '-'));
</script>
